<template>
  <div class="mt-2">
    <mf-action-buttons
      v-if="newCampaign"
      :primary-button="{
        text: 'Ativar vale-troca',
        action: saveActive,
        isVisible: true,
        isLoading: loading.saveActive,
        isDisabled: anyLoading && !loading.saveActive,
      }"
      :secondary-button="{
        text: 'Salvar rascunho',
        action: saveDraft,
        isVisible: true,
        isLoading: loading.saveDraft,
        isDisabled: anyLoading && !loading.saveDraft,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: redirectCampanhas,
        isVisible: true,
      }"
    />

    <mf-action-buttons
      v-else-if="scheduledCampaign"
      :primary-button="{
        text: 'Salvar alterações',
        action: saveActive,
        isVisible: true,
        isLoading: loading.saveActive,
        isDisabled: anyLoading && !loading.saveActive,
      }"
      :extra-button="{
        text: 'Suspender',
        action: unscheduleVoucher,
        isVisible: true,
        isLoading: loading.unscheduleVoucher,
        isDisabled: anyLoading && !loading.unscheduleVoucher,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: redirectCampanhas,
        isVisible: true,
      }"
    />

    <mf-action-buttons
      v-else-if="activeCampaign"
      :primary-button="{
        text: 'Salvar alterações',
        action: saveActive,
        isVisible: true,
        isLoading: loading.saveActive,
        isDisabled: anyLoading && !loading.saveActive,
      }"
      :extra-button="{
        text: 'Finalizar',
        action: finalizeVoucher,
        isVisible: true,
        isLoading: loading.disableDraft,
        isDisabled: anyLoading && !loading.saveDraft,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: redirectCampanhas,
        isVisible: true,
      }"
    />

    <mf-action-buttons
      v-else-if="finishedCampaign"
      :primary-button="{
        text: 'Duplicar',
        action: clone,
        isVisible: true,
        isLoading: loading.clone,
        isDisabled: anyLoading && !loading.clone,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: redirectCampanhas,
        isVisible: true,
      }"
    />

    <mf-action-buttons
      v-else
      :primary-button="{
        text: 'Ativar vale-troca',
        action: saveActive,
        isVisible: true,
        isLoading: loading.saveActive,
        isDisabled: anyLoading && !loading.saveActive,
      }"
      :secondary-button="{
        text: 'Salvar alterações',
        action: saveDraft,
        isVisible: true,
        isLoading: loading.saveDraft,
        isDisabled: anyLoading && !loading.saveDraft,
      }"
      :cancel-button="{
        text: 'Cancelar',
        action: redirectCampanhas,
        isVisible: true,
      }"
    />
  </div>
</template>

<script>
import { MUTATION_FINALIZE_VOUCHER, MUTATION_CLONE_VOUCHER, MUTATION_UNSCHEDULED_VOUCHER } from '../../../graphql'

export default {
  props: {
    object: Object,
    save: Function,
  },
  data: () => ({
    loading: {
      saveDraft: false,
      saveActive: false,
      clone: false,
      unscheduleVoucher: false,
    },
  }),
  computed: {
    newCampaign() {
      return !this.object._id
    },
    activeCampaign() {
      return ['ACTIVE'].includes(this.object.status)
    },
    scheduledCampaign() {
      return ['SCHEDULED'].includes(this.object.status)
    },
    finishedCampaign() {
      return ['FINISHED'].includes(this.object.status)
    },
    anyLoading() {
      return Object.values(this.loading).some((value) => value)
    },
  },
  methods: {
    async saveDraft() {
      this.loading.saveDraft = true
      try {
        await this.save(true)
      } catch {
        this.$snackbar({ message: 'Ocorreu um erro ao salvar campanha.' })
      } finally {
        this.loading.saveDraft = false
      }
    },
    async saveActive() {
      this.loading.saveActive = true
      try {
        await this.save(false)
      } catch {
        this.$snackbar({ message: 'Ocorreu um erro ao salvar campanha.' })
      } finally {
        this.loading.saveActive = false
      }
    },
    async finalizeVoucher() {
      const confirmed = await this.$confirm({
        title: 'Finalizar vale-troca',
        message:
          'Finalizando esse vale-troca ele deixará de ser exibido no aplicativo, e portanto, não poderá receber novas ativações, mas não cancelará os que já foram ativados por consumidores.',
        confirmText: 'Finalizar',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)

      if (!confirmed) return

      this.loading.clone = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_FINALIZE_VOUCHER,
          variables: { id: this.object._id },
        })
        .then(this.redirectCampanhas)
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.delete'))
        })
      this.loading.clone = false
    },
    async unscheduleVoucher() {
      const confirmed = await this.$confirm({
        title: 'Suspender vale-troca',
        message: 'Tem certeza que deseja suspender este vale-troca?',
        confirmText: 'Suspender',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)

      if (!confirmed) return

      this.loading.unscheduleVoucher = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_UNSCHEDULED_VOUCHER,
          variables: { id: this.object._id },
        })
        .then(this.redirectCampanhas)
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.unschedule'))
        })
      this.loading.unscheduleVoucher = false
    },
    async clone() {
      const confirmed = await this.$confirm({
        ...this.$t('campanhas.confirmations.clone'),
        message: `Deseja duplicar ${this.object.title ? 'o vale-troca ' + this.object.title.trim().bold() : 'este vale-troca'}?`,
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      this.loading.clone = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_CLONE_VOUCHER,
          variables: {
            id: this.object._id,
          },
        })
        .then(
          ({
            data: {
              cloneVoucher: { _id: newId },
            },
          }) => {
            this.$router.push(`/mobile/pontos/${newId}`).catch(() => {})
          }
        )
        .catch(() => {
          this.$snackbar(this.$t('campanhas.snackbars.errors.clone'))
        })
      this.loading.clone = false
    },
    redirectCampanhas() {
      this.$router.push('/mobile/pontos/').catch(() => {})
    },
  },
}
</script>
